// ─── Permission Groups ───────────────────────────────────────────
export const G = {
    // Profiles
    ADMIN: 'administrator',
    TECHNICIAN: 'technician',
    PLANNER: 'planner',
    BACKOFFICE: 'backoffice-manager',
    LOGISTICIAN: 'logistician',
    HSE_MGR: 'hse-manager',
    ACTIVITY_SUPERVISOR: 'activity-supervisor',
    MANAGER: 'manager',
    VALIDATOR_231: 'validator-231',
    MANAGER_231: 'manager-231',
    MOBILE_WORKER: 'mobile-worker',
    COMMERCIAL: 'commercial',
    MARKETING: 'marketing',
    SUPPORT: 'support',
    HSE_SUPERVISOR: 'hse-supervisor',
    B2B_COORDINATOR: 'b2b-coordinator',
    COMMISSION_PM: 'commission-pm',
    PROSAT: 'prosat',
    COMMISSION_SPECIALIST: 'commission-specialist',
    DATA_ANALYST: 'data-analyst',
    // Commission roles
    C_B2B: 'commission-role-b2b-coordinator',
    C_PM: 'commission-role-pm',
    C_RL: 'commission-role-rl',
    C_CSP: 'commission-role-csp',
    C_CSE: 'commission-role-cse',
    C_ENGINEER: 'commission-role-engineer',
    C_PARTNER: 'commission-role-partner-coordinator',
    C_INT_PERM: 'commission-role-internal-permitting',
    C_EXT_PERM: 'commission-role-external-permitting',
    C_CONSTR_MGR: 'commission-role-construction-manager',
    C_CONSTR_AST: 'commission-role-construction-assistant',
    C_PROSAT: 'commission-role-prosat',
    C_PM_HSE: 'commission-role-pm-hse',
    C_LOGISTICIAN: 'commission-role-logistician',
    C_PROCURATOR_LEV1: 'commission-role-procurator-lev1',
    C_PROCURATOR_LEV2: 'commission-role-procurator-lev2',
    // Qualification roles
    Q_OPERATOR: 'qualification-operator',
    Q_MANAGER: 'qualification-manager',
    Q_DD_VALIDATOR: 'dd-validator'
};

export const allow = (...groups) => {
    const meta = { publicRoute: false };
    groups.flat().forEach(g => { meta[g] = true; });
    return meta;
};

// ─── Preset Groups ───────────────────────────────────────────────
export const ALL_COMMISSION_ROLES = [
    G.C_B2B, G.C_PM, G.C_RL, G.C_CSP, G.C_CSE,
    G.C_ENGINEER, G.C_PARTNER,
    G.C_INT_PERM, G.C_EXT_PERM,
    G.C_CONSTR_MGR, G.C_CONSTR_AST, G.C_PROSAT,
    G.C_PM_HSE, G.C_LOGISTICIAN,
    G.C_PROCURATOR_LEV1, G.C_PROCURATOR_LEV2,
];

export const ALL_PROFILES = [
    G.ADMIN, G.TECHNICIAN, G.PLANNER, G.BACKOFFICE,
    G.LOGISTICIAN, G.HSE_MGR, G.ACTIVITY_SUPERVISOR, G.MANAGER,
    G.VALIDATOR_231, G.MANAGER_231, G.MOBILE_WORKER,
    G.COMMERCIAL, G.MARKETING, G.SUPPORT, G.HSE_SUPERVISOR,
    G.B2B_COORDINATOR, G.COMMISSION_PM, G.PROSAT, G.COMMISSION_SPECIALIST,
    G.Q_OPERATOR, G.Q_MANAGER, G.Q_DD_VALIDATOR, G.DATA_ANALYST
];

export const EVERYONE = [...ALL_PROFILES, ...ALL_COMMISSION_ROLES];

export const ADMIN_SUPPORT = [G.ADMIN, G.SUPPORT];
export const ADMIN_HSE = [G.ADMIN, G.HSE_MGR, G.SUPPORT, G.HSE_SUPERVISOR];
export const ADMIN_HSE_COMMISSION_MODELS = [...ADMIN_HSE, G.C_B2B, G.C_PM, G.C_PROSAT];
export const ADMIN_SETUP = [G.ADMIN, G.SUPPORT, G.C_B2B];
export const PQ_ACCESS = [G.Q_OPERATOR, G.Q_MANAGER, G.ADMIN, G.SUPPORT];
export const PQ_ADMIN = [G.Q_MANAGER, G.ADMIN, G.SUPPORT];